import React, { MouseEvent, useState } from 'react';
import ButtonWithStatus, {
  LoadingStatus,
} from '../../ButtonWithStatus';

const FileUploadForm: React.FC = () => {
  const [investFile, setInvestFile] = useState<File>();
  const [addressFile, setAddressFile] = useState<File>();
  const [zipcodeFile, setZipcodeFile] = useState<File>();
  const [uploadStatus, setUploadStatus] = useState<LoadingStatus>(
    LoadingStatus.IDLE
  );
  const [feedbackText, setFeedbackText] = useState<string>('');

  const handleParameterFile = (
    event: React.ChangeEvent<HTMLInputElement>,
    setFile: React.Dispatch<React.SetStateAction<File | undefined>>
  ) => {
    if (!event.target.files) {
      setFile(undefined);
    } else if (
      event.target.files[0].type ===
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ) {
      setFile(event.target.files[0]);
    }
  };

  const uploadFile = async (url: string, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    const res = await fetch(url, {
      method: 'POST',
      body: formData,
      credentials: 'include',
    });

    if (!res.ok) {
      let message = '';
      try {
        const contentType = res.headers.get('content-type') || '';
        if (contentType.includes('application/json')) {
          const data = await res.json();
          message =
            data?.message ||
            data?.error ||
            (typeof data === 'string' ? data : JSON.stringify(data));
        } else {
          message = await res.text();
        }
      } catch {
        // ignore parsing errors
      }
      const prefix = `${res.status} ${res.statusText}`;
      throw new Error(message ? `${prefix}: ${message}` : prefix);
    }
  };

  const uploadFiles = async (event: MouseEvent) => {
    if (
      investFile &&
      addressFile &&
      zipcodeFile &&
      uploadStatus !== LoadingStatus.LOADING
    ) {
      setUploadStatus(LoadingStatus.LOADING);
      setFeedbackText('Uploading ...');

      const results = await Promise.allSettled([
        uploadFile(
          `${window.__ENV__.REACT_APP_FORMULAR_API}/api/import/agents`,
          investFile
        ),
        uploadFile(
          `${window.__ENV__.REACT_APP_FORMULAR_API}/api/import/adresses`,
          addressFile
        ),
        uploadFile(
          `${window.__ENV__.REACT_APP_FORMULAR_API}/api/import/zipcodes`,
          zipcodeFile
        ),
      ]);

      const failures = results.filter(
        (r) => r.status === 'rejected'
      ) as PromiseRejectedResult[];

      if (failures.length > 0) {
        const messages = failures
          .map(
            (f) =>
              (f.reason && (f.reason.message || String(f.reason))) ||
              'Unbekannter Fehler'
          )
          .join(' | ');
        setUploadStatus(LoadingStatus.FAILED);
        setFeedbackText(`Upload fehlgeschlagen: ${messages}`);
      } else {
        setUploadStatus(LoadingStatus.SUCCESFUL);
        setFeedbackText('Upload erfolgreich');
      }
    }
  };

  return (
    <>
      <form>
        <div className="container border p-3">
          <div className="form-group">
            <label className="form-control-label">
              Wähle hier die Invest-Excel-Datei aus
            </label>
            <input
              className="form-control-file"
              id="invest-file-upload-input"
              type="file"
              accept=".xlsx"
              onChange={(e) => handleParameterFile(e, setInvestFile)}
            />
          </div>
          <div className="form-group">
            <label className="form-control-label">
              Wähle hier die Address-Excel-Datei aus
            </label>
            <input
              className="form-control-file"
              id="address-file-upload-input"
              type="file"
              accept=".xlsx"
              onChange={(e) => handleParameterFile(e, setAddressFile)}
            />
          </div>
          <div className="form-group">
            <label className="form-control-label">
              Wähle hier die Zipcode-Excel-Datei aus
            </label>
            <input
              className="form-control-file"
              id="zipcode-file-upload-input"
              type="file"
              accept=".xlsx"
              onChange={(e) => handleParameterFile(e, setZipcodeFile)}
            />
          </div>
          {investFile && addressFile && zipcodeFile ? (
            <div className="valid-feedback d-block">
              Excel Dateien wurden ausgewählt
            </div>
          ) : (
            <div className="invalid-feedback d-block">
              Excel Dateien wurden nicht ausgewählt
            </div>
          )}
          <ButtonWithStatus
            feedbackText={feedbackText}
            status={uploadStatus}
            onclick={uploadFiles}
          >
            Datei hochladen
          </ButtonWithStatus>
        </div>
      </form>
    </>
  );
};

export default FileUploadForm;
